import { configureStore } from "@reduxjs/toolkit";
import appReducer from "./slices/appslice";
import appInitReducer from "./slices/appinitslice";
import appearanceReducer from "./slices/appearanceslice";
import currentThemeReducer from "./slices/currentthemeslice";
import currentUserReducer from "./slices/currentuserslice";
import currentPageReducer from "./slices/currentpageslice";
import internetStatusReducer from "./slices/internetstatusslice";
import notificationsReducer from "./slices/notificationsslice";
import notificationsCounterReducer from "./slices/notificationscounterslice";
import notificationsPageReducer from "./slices/notificationspageslice";
import appLoaderReducer from "./slices/apploaderslice";
import welcomeScreenReducer from "./slices/welcomescreenslice";
import appDialogReducer from "./slices/appdialogslice";
import genericErrorPageReducer from "./slices/genericerrorpageslice";
import unAuthorizedPageReducer from "./slices/unauthorizedpageslice";
import loginPageReducer from "./slices/loginpageslice";
import expressionsPageReducer from "./slices/expressionspageslice";
import dataSourcesPageReducer from "./slices/datasourcespageslice";
import alertsPageReducer from "./slices/alertspageslice";
import reportingLocatorPageReducer from "./slices/reportinglocatorpageslice";
import reportingDesignPageReducer from "./slices/reportingdesignpageslice";
import reportingViewPageReducer from "./slices/reportingviewpageslice";
import usersPageReducer from "./slices/userspageslice";
import securityGroupsPageReducer from "./slices/securitygroupspageslice";
import migrationsPageReducer from "./slices/migrationspageslice";
import reportsMenuPageReducer from "./slices/reportsmenupageslice";
import dataConsumptionPageReducer from "./slices/dataconsumptionpageslice";
import signalRReducer from "./slices/signalrslice";
import dictaphoneReducer from "./slices/dictaphoneslice";
import entityClonerReducer from "./slices/entityclonerslice";
import resetPasswordPageReducer from "./slices/resetpasswordpageslice";
import datasetsLocatorPageReducer from "./slices/datasetslocatorpageslice";
import datasetViewPageReducer from "./slices/datasetviewpageslice";
import createDatasetPageReducer from "./slices/createdatasetpageslice";
import importDatasetPageReducer from "./slices/importdatasetpageslice";
import dataCorrectionPageReducer from "./slices/datacorrectionpageslice";
import accountManagementPageReducer from "./slices/accountmanagementslice";
import menuReducer from "./slices/menuslice";
import homeReducer from "./slices/homepageslice";
import onBoardingReducer from "./slices/onboardingpageslice";
import plansReducer from "./slices/planslice";
import scheduleLocatorPageReducer from "./slices/schedulelocatorpageslice";
import scheduleViewPageReducer from "./slices/scheduleviewpageslice";
import createSchedulePageReducer from "./slices/createschedulepageslice";
import importSchedulePageReducer from "./slices/importschedulepageslice";
import connectionLocatorPageReducer from "./slices/connectionlocatorpageslice";

let store = configureStore({
  reducer: {
    app: appReducer,
    appInit: appInitReducer,
    appearance: appearanceReducer,
    currentTheme: currentThemeReducer,
    currentUser: currentUserReducer,
    currentPage: currentPageReducer,
    internetStatus: internetStatusReducer,
    notifications: notificationsReducer,
    notificationsCounter: notificationsCounterReducer,
    notificationsPage: notificationsPageReducer,
    appLoader: appLoaderReducer,
    welcomeScreen: welcomeScreenReducer,
    appDialog: appDialogReducer,
    genericErrorPage: genericErrorPageReducer,
    unAuthorizedPage: unAuthorizedPageReducer,
    loginPage: loginPageReducer,
    expressionsPage: expressionsPageReducer,
    dataSourcesPage: dataSourcesPageReducer,
    alertsPage: alertsPageReducer,
    reportingLocatorPage: reportingLocatorPageReducer,
    reportingDesignPage: reportingDesignPageReducer,
    reportingViewPage: reportingViewPageReducer,
    usersPage: usersPageReducer,
    securityGroupsPage: securityGroupsPageReducer,
    migrationsPage: migrationsPageReducer,
    reportsMenuPage: reportsMenuPageReducer,
    dictaphone: dictaphoneReducer,
    signalR: signalRReducer,
    entityCloner: entityClonerReducer,
    dataConsumptionPage: dataConsumptionPageReducer,
    resetPasswordPage: resetPasswordPageReducer,
    datasetsLocatorPage: datasetsLocatorPageReducer,
    datasetViewPage: datasetViewPageReducer,
    createDatasetPage: createDatasetPageReducer,
    importDatasetPage: importDatasetPageReducer,
    menu: menuReducer,
    dataCorrectionPage: dataCorrectionPageReducer,
    accountManagementPage: accountManagementPageReducer,
    home:homeReducer,
    onBoardingPage: onBoardingReducer,
    plans: plansReducer,    
    scheduleLocatorPage: scheduleLocatorPageReducer,
    scheduleViewPage: scheduleViewPageReducer,
    createSchedulePage: createSchedulePageReducer,
    importSchedulePage: importSchedulePageReducer,
    connectionLocatorPage: connectionLocatorPageReducer,
  },
  //below to disable getting browser error that state contains non-serializable items
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
